<dashboardnav>
  <cradua-continent
  [continents]="continents$ | async"
  (continent)="onSubmitContinent($event)"
  (deleteContinentEvent)="onDeleteContinent($event)"
  *ngIf="(isLoadingContinent$ | async ) === false"
  >
</cradua-continent>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingContinent$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
